<template>
    <div class="app-shell">
        <v-system-bar
            v-if="showNotificationPermissionBanner"
            app
            height="44"
            color="warning"
            class="notification-permission-banner"
            @click="enableAdminNotifications"
        >
            <v-icon small class="mr-2">mdi-bell-alert</v-icon>
            <span class="notification-permission-text">
                <span class="d-none d-sm-inline">Ative as notificações do navegador para receber solicitações operacionais em tempo real.</span>
                <span class="d-sm-none">Ative as notificações</span>
            </span>
            <v-btn small text :loading="notificationPermissionLoading" @click.stop="enableAdminNotifications">
                Permitir
            </v-btn>
            <v-btn small text @click.stop="dismissNotificationBanner">Agora não</v-btn>
        </v-system-bar>

        <v-app-bar app color="white" elevation="0" clipped-left height="64" class="app-topbar">
            <v-app-bar-nav-icon id="menuItem" class="mr-2" :title="isDesktop ? (mini ? 'Expandir menu' : 'Recolher menu') : 'Menu'"
                @click.stop="toggleMenu"></v-app-bar-nav-icon>

            <router-link to="/home" class="d-flex align-center">
                <v-img id="logo" class="logo" src="@/assets/images/logo-onix.png" max-height="44" width="104"
                    contain></v-img>
            </router-link>

            <v-spacer></v-spacer>

            <v-menu v-model="notificationMenu" offset-y min-width="360" max-width="420" @input="handleNotificationMenuToggle">
                <template v-slot:activator="{ on, attrs }">
                    <v-btn icon v-bind="attrs" v-on="on" class="mr-4">
                        <v-badge :content="unreadCount" :value="unreadCount > 0" color="red" overlap>
                            <v-icon color="dark">mdi-bell</v-icon>
                        </v-badge>
                    </v-btn>
                </template>
                <v-list class="notification-menu">
                    <v-list-item>
                        <v-list-item-content>
                            <v-list-item-title class="font-weight-bold">Notificações</v-list-item-title>
                        </v-list-item-content>
                        <v-btn small text color="primary" :disabled="!unreadCount" @click.stop="markAllNotificationsRead">
                            Marcar lidas
                        </v-btn>
                    </v-list-item>

                    <v-divider></v-divider>

                    <v-list-item v-if="notificationsLoading">
                        <v-list-item-content>
                            <v-list-item-title class="mediumGray--text">Carregando...</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>

                    <v-list-item v-else-if="!notifications.length">
                        <v-list-item-content>
                            <v-list-item-title class="mediumGray--text">Nenhuma notificação</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>

                    <template v-for="(notification, index) in notifications">
                        <v-list-item :key="notification.id || index" @click="openNotification(notification)">
                            <v-list-item-icon class="mr-3">
                                <v-icon :color="notification.read_at ? 'mediumGray' : 'primary'" small>
                                    {{ notification.read_at ? 'mdi-bell-outline' : 'mdi-bell-ring' }}
                                </v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                                <v-list-item-title :class="{ 'font-weight-bold': !notification.read_at }">
                                    {{ notification.title }}
                                </v-list-item-title>
                                <v-list-item-subtitle class="notification-message">
                                    {{ notification.message }}
                                </v-list-item-subtitle>
                                <v-list-item-subtitle>
                                    {{ formatNotificationTime(notification) }}
                                </v-list-item-subtitle>
                            </v-list-item-content>
                        </v-list-item>
                        <v-divider :key="'divider-' + index"></v-divider>
                    </template>

                    <v-list-item @click="viewAllNotifications">
                        <v-list-item-title class="text-center primary--text">Ver todas as
                            notificações</v-list-item-title>
                    </v-list-item>
                </v-list>
            </v-menu>


            <v-menu min-width="200" offset-y>
                <template v-slot:activator="{ on, attrs }">
                    <div class="logged-user d-none d-sm-flex ml-2" v-bind="attrs" v-on="on">
                        <span class="logged-user-name font-weight-bold dark--text">{{ user ? user.name : 'Usuário'
                        }}</span>
                        <span class="logged-user-email mediumGray--text">{{ user ? user.email : 'email@exemplo.com'
                        }}</span>
                    </div>

                    <v-avatar size="38" color="primary" class="user-avatar" v-bind="attrs" v-on="on">
                        <span class="white--text">{{ userInitials }}</span>
                    </v-avatar>
                </template>
                <v-list>
                    <template v-for="(menuOption, index) in profileMenu">
                        <MenuItem :key="index" :item="menuOption" v-if="!menuOption || !menuOption.children">
                        </MenuItem>
                    </template>
                </v-list>
            </v-menu>
        </v-app-bar>

        <AppSidebar v-model="drawer" :mini="mini" :desktop="isDesktop" @toggle-mini="toggleMenu" />

        <div class="app-content">
            <router-view></router-view>
        </div>

        <v-snackbar v-model="snackbar.show" :color="snackbar.color" :timeout="snackbar.timeout" bottom right>
            {{ snackbar.message }}
            <template v-slot:action="{ attrs }">
                <v-btn text v-bind="attrs" @click="snackbar.show = false">
                    Fechar
                </v-btn>
            </template>
        </v-snackbar>
    </div>
</template>

<script>
// import userApi from "@/common/api/user.api";
import { eventHub } from "@/main";

import router from '../router';
import axios from "axios";

import MenuItem from "@/layouts/components/MenuItem";
//import toolbarMenu from "@/common/data/toolbar-menu.data"
import profileMenu from "@/common/data/profile-menu.data"
import AppSidebar from "@/layouts/components/AppSidebar.vue"

export default {
    name: "PrivateLayout",

    components: {
        MenuItem,
        AppSidebar
    },

    data() {
        return {
            logoUrl: null,
            menuGroups: [],
            drawer: false,
            searchTerm: null,
            user: null,
            displaySettingsMenu: false,
            // toolbarMenu: toolbarMenu,
            profileMenu: profileMenu,
            notificationMenu: false,
            mini: false,
            notificationBannerDismissed: false,
            unreadCount: 0,
            notifications: [],
            notificationsLoading: false,
            notificationPolling: null,
            latestAdminNotificationId: null,
            latestAdminNotificationInitialized: false,
            browserNotifiedNotificationIds: [],
            notificationAudioContext: null,
            notificationAudioUnlocked: false,
            notificationPermission: 'unsupported',
            notificationPermissionLoading: false,
            oneSignalInitialized: false,
            oneSignalPushOptedIn: null,
            adminPushConfig: null,
            snackbar: {
                show: false,
                message: '',
                color: 'info',
                timeout: 5000,
            },
        };
    },

    computed: {
        routeName() {
            return this.$route.name;
        },

        isDesktop() {
            return this.$vuetify.breakpoint.lgAndUp;
        },

        userInitials() {
            const name = (this.user && this.user.name) || 'Usuário';
            const parts = name.trim().split(/\s+/);
            return ((parts[0] || '')[0] + (parts.length > 1 ? parts[parts.length - 1][0] : '')).toUpperCase();
        },

        showNotificationPermissionBanner() {
            return !this.notificationBannerDismissed &&
                this.supportsAdminNotifications() &&
                (this.notificationPermission !== 'granted' ||
                    this.oneSignalPushOptedIn === false);
        },
    },

    created() {

        this.user = this.$root.user.data || this.$root.user;

        this.mini = this.readPreference('onix-menu-mini') === '1';
        this.drawer = this.isDesktop;
        this.notificationBannerDismissed = Number(this.readPreference('onix-notification-banner-ate') || 0) > Date.now();

        // eventHub.$on("close-menu", () => {
        //     this.closeMenu();
        // });

        this.loadAdminNotifications();
        this.loadUnreadNotificationsCount({ playSoundOnIncrease: false });
        this.checkLatestAdminNotification();
        this.startNotificationPolling();

        eventHub.$on("new-notification", this.showSnackbar);

        eventHub.$on("logout", () => {
            this.logout();
        });

        this.setActionButtons();
    },

    mounted() {
        this.syncNotificationPermission();
        this.initializeOneSignalAdminPush(false);
        this.registerAdminPushSubscription(false);
        window.addEventListener('focus', this.handleNotificationWindowFocus);
        window.addEventListener('pointerdown', this.unlockNotificationAudio, { once: true });
        window.addEventListener('keydown', this.unlockNotificationAudio, { once: true });
    },

    destroyed() {
        eventHub.$off("THEME_UPDATED");
        eventHub.$off("new-notification", this.showSnackbar);
        eventHub.$off("logout");
        if (this.notificationPolling) {
            clearInterval(this.notificationPolling);
        }
        window.removeEventListener('focus', this.handleNotificationWindowFocus);
        window.removeEventListener('pointerdown', this.unlockNotificationAudio);
        window.removeEventListener('keydown', this.unlockNotificationAudio);
        if (this.notificationAudioContext) {
            this.notificationAudioContext.close().catch(() => {});
        }
    },

    watch: {
        isDesktop(value) {
            this.drawer = value;
            this.notifyLayoutResize();
        },
    },

    methods: {
        toggleMenu() {
            if (!this.isDesktop) {
                this.drawer = !this.drawer;
                return;
            }

            this.mini = !this.mini;
            this.writePreference('onix-menu-mini', this.mini ? '1' : '0');
            this.notifyLayoutResize();
        },

        // Gráficos (ApexCharts) só recalculam a largura no resize da janela:
        // avisamos quando o menu abre/recolhe, depois da animação do drawer
        notifyLayoutResize() {
            setTimeout(() => window.dispatchEvent(new Event('resize')), 260);
        },

        // Banner some por 7 dias; o botão de permitir continua no sino
        dismissNotificationBanner() {
            this.notificationBannerDismissed = true;
            this.writePreference('onix-notification-banner-ate', String(Date.now() + 7 * 24 * 60 * 60 * 1000));
        },

        readPreference(key) {
            try {
                return window.localStorage.getItem(key);
            } catch (error) {
                return null;
            }
        },

        writePreference(key, value) {
            try {
                window.localStorage.setItem(key, value);
            } catch (error) {
                // Sem localStorage: a preferência vale só nesta sessão
            }
        },

        setActionButtons() {
            // Grupo
        },

        // closeMenu() {
        //     this.$refs.menu.save()
        // },

        menuActionClick(event) {
            event.preventDefault()
        },

        shouldDisplayMenuGroup(menuGroup) {
            const hasParentPermission = menuGroup.permissions.some((permission) =>
                this.$check([permission])
            );

            const hasChildPermission = menuGroup.children.some((child) =>
                this.$check(child.permissions)
            );

            return hasParentPermission || hasChildPermission;
        },

        async logout() {
            // if (await this.$root.$confirm(true, "user.logout")) {
            //     userApi.clearcurrentUser;
            //     this.$router.push({ name: "Login" });
            // }

            console.log('logout')

            localStorage.clear();
            router.push("/login");
        },

        showSnackbar(notificationData) {
            try {
                console.log('PrivateLayout: Evento "new-notification" recebido.', notificationData);
                this.snackbar.message = notificationData.message || 'Nova notificação!';
                this.snackbar.color = notificationData.color || 'info';
                this.snackbar.show = true;
                this.playNotificationSound();
                this.loadAdminNotifications();
                this.loadUnreadNotificationsCount({ playSoundOnIncrease: false });
            } catch (error) {
                console.error("Erro ao processar notificação no showSnackbar:", error, notificationData);
            }
        },

        async loadAdminNotifications(limit = 10) {
            this.notificationsLoading = true;

            try {
                const response = await axios.get('/api/v2/admin-notifications', {
                    params: { page: 1, limit },
                });
                const content = response.data && response.data.content ? response.data.content : {};
                this.notifications = content.data || [];
            } catch (error) {
                console.error('Erro ao carregar notificações administrativas:', error);
            } finally {
                this.notificationsLoading = false;
            }
        },

        async loadUnreadNotificationsCount(options = {}) {
            try {
                const previousUnreadCount = this.unreadCount;
                const response = await axios.get('/api/v2/admin-notifications/unread-count');
                const content = response.data && response.data.content ? response.data.content : {};
                this.unreadCount = content.total || 0;

                if (options.playSoundOnIncrease !== false && this.unreadCount > previousUnreadCount) {
                    this.playNotificationSound();
                    await this.showLatestBrowserNotification();
                }
            } catch (error) {
                console.error('Erro ao carregar contador de notificações:', error);
            }
        },

        async handleNotificationMenuToggle(open) {
            if (!open) return;

            await this.loadAdminNotifications();
            await this.markVisibleNotificationsRead();
        },

        async markVisibleNotificationsRead() {
            const ids = this.notifications
                .filter((notification) => !notification.read_at)
                .map((notification) => notification.id);

            if (!ids.length) return;

            try {
                await axios.patch('/api/v2/admin-notifications/read-many', { ids });
                const readAt = new Date().toISOString();
                this.notifications = this.notifications.map((notification) => {
                    if (!ids.includes(notification.id)) return notification;
                    return { ...notification, read_at: readAt, read: true };
                });
                await this.loadUnreadNotificationsCount();
            } catch (error) {
                console.error('Erro ao marcar notificações como lidas:', error);
            }
        },

        async markAllNotificationsRead() {
            try {
                await axios.patch('/api/v2/admin-notifications/read-all');
                const readAt = new Date().toISOString();
                this.notifications = this.notifications.map((notification) => ({
                    ...notification,
                    read_at: notification.read_at || readAt,
                    read: true,
                }));
                await this.loadUnreadNotificationsCount();
            } catch (error) {
                console.error('Erro ao marcar todas as notificações como lidas:', error);
            }
        },

        async openNotification(notification) {
            await this.markNotificationRead(notification);
            this.notificationMenu = false;

            const url = notification.url || null;
            if (!url) return;

            const normalizedUrl = url.replace(/^\/#/, '');
            if (normalizedUrl && normalizedUrl.startsWith('/')) {
                this.$router.push(normalizedUrl).catch(() => {});
            }
        },

        async markNotificationRead(notification) {
            if (!notification || !notification.id || notification.read_at) return;

            try {
                await axios.patch(`/api/v2/admin-notifications/${notification.id}/read`);
                notification.read_at = new Date().toISOString();
                notification.read = true;
                await this.loadUnreadNotificationsCount();
            } catch (error) {
                console.error('Erro ao marcar notificação como lida:', error);
            }
        },

        viewAllNotifications() {
            this.notificationMenu = false;
            this.$router.push('/notificacoes').catch(() => {});
        },

        formatNotificationTime(notification) {
            if (!notification || !notification.created_at) return '';
            return this.$moment(notification.created_at).format('DD/MM/YYYY HH:mm');
        },

        startNotificationPolling() {
            if (this.notificationPolling) clearInterval(this.notificationPolling);

            this.notificationPolling = setInterval(() => {
                this.loadUnreadNotificationsCount({ playSoundOnIncrease: true });
                this.checkLatestAdminNotification();
                if (this.notificationMenu) {
                    this.loadAdminNotifications();
                }
            }, 10000);
        },

        unlockNotificationAudio() {
            const AudioContext = window.AudioContext || window.webkitAudioContext;
            if (!AudioContext) return;

            if (!this.notificationAudioContext) {
                this.notificationAudioContext = new AudioContext();
            }

            if (this.notificationAudioContext.state === 'suspended') {
                this.notificationAudioContext.resume().catch(() => {});
            }

            this.notificationAudioUnlocked = true;
        },

        playNotificationSound() {
            try {
                const AudioContext = window.AudioContext || window.webkitAudioContext;
                if (!AudioContext) return;

                if (!this.notificationAudioContext) {
                    this.notificationAudioContext = new AudioContext();
                }

                const audioContext = this.notificationAudioContext;
                if (audioContext.state === 'suspended') {
                    audioContext.resume().catch(() => {});
                    if (!this.notificationAudioUnlocked) return;
                }

                const oscillator = audioContext.createOscillator();
                const gain = audioContext.createGain();
                const startTime = audioContext.currentTime;

                oscillator.type = 'sine';
                oscillator.frequency.setValueAtTime(880, startTime);
                oscillator.frequency.setValueAtTime(1174, startTime + 0.12);

                gain.gain.setValueAtTime(0.0001, startTime);
                gain.gain.exponentialRampToValueAtTime(0.18, startTime + 0.02);
                gain.gain.exponentialRampToValueAtTime(0.0001, startTime + 0.32);

                oscillator.connect(gain);
                gain.connect(audioContext.destination);
                oscillator.start(startTime);
                oscillator.stop(startTime + 0.34);
            } catch (error) {
                console.error('Erro ao reproduzir som de notificação:', error);
            }
        },

        async checkLatestAdminNotification() {
            try {
                const response = await axios.get('/api/v2/admin-notifications', {
                    params: { page: 1, limit: 1 },
                });
                const content = response.data && response.data.content ? response.data.content : {};
                const notification = content.data && content.data.length ? content.data[0] : null;

                if (!this.latestAdminNotificationInitialized) {
                    this.latestAdminNotificationId = notification && notification.id ? notification.id : null;
                    this.latestAdminNotificationInitialized = true;
                    return;
                }

                if (!notification || !notification.id) return;

                if (notification.id === this.latestAdminNotificationId) return;

                this.latestAdminNotificationId = notification.id;
                this.playNotificationSound();
                await this.showLatestBrowserNotification(notification);
            } catch (error) {
                console.error('Erro ao verificar última notificação administrativa:', error);
            }
        },

        async showLatestBrowserNotification(notification = null) {
            try {
                if (!('Notification' in window) || Notification.permission !== 'granted') return;

                if (!notification) {
                    const response = await axios.get('/api/v2/admin-notifications', {
                        params: { page: 1, limit: 1 },
                    });
                    const content = response.data && response.data.content ? response.data.content : {};
                    notification = content.data && content.data.length ? content.data[0] : null;
                }

                if (!notification || !notification.id || notification.read_at) return;
                if (this.browserNotifiedNotificationIds.includes(notification.id)) return;

                this.browserNotifiedNotificationIds.push(notification.id);
                this.browserNotifiedNotificationIds = this.browserNotifiedNotificationIds.slice(-30);

                const browserNotification = new Notification(notification.title || 'ONIX', {
                    body: notification.message || 'Nova notificação',
                    icon: '/favicon.ico',
                    tag: `onix-admin-notification-${notification.id}`,
                });

                browserNotification.onclick = () => {
                    window.focus();
                    this.openNotification(notification);
                    browserNotification.close();
                };
            } catch (error) {
                console.error('Erro ao exibir notificação nativa no navegador:', error);
            }
        },

        supportsAdminNotifications() {
            return 'serviceWorker' in navigator &&
                'PushManager' in window &&
                'Notification' in window &&
                window.isSecureContext;
        },

        syncNotificationPermission() {
            this.notificationPermission = this.supportsAdminNotifications()
                ? Notification.permission
                : 'unsupported';
        },

        handleNotificationWindowFocus() {
            this.syncNotificationPermission();
            this.initializeOneSignalAdminPush(false);
            this.registerAdminPushSubscription(false);
        },

        async enableAdminNotifications() {
            await this.initializeOneSignalAdminPush(true);
            await this.registerAdminPushSubscription(true);
        },

        async loadAdminPushConfig() {
            if (this.adminPushConfig) return this.adminPushConfig;

            const response = await axios.get('/api/v2/admin-push-subscriptions/config');
            this.adminPushConfig = response.data && response.data.content ? response.data.content : {};

            return this.adminPushConfig;
        },

        async initializeOneSignalAdminPush(requestPermission = false) {
            if (!this.supportsAdminNotifications()) return;
            window.OneSignalDeferred = window.OneSignalDeferred || [];

            try {
                const config = await this.loadAdminPushConfig();
                const appId = config.oneSignalAppId;

                if (!appId) return;

                const externalId = this.user && this.user.id ? String(this.user.id) : null;
                if (!externalId) return;

                window.OneSignalDeferred.push(async (OneSignal) => {
                    try {
                        await this.unregisterInternalAdminPushWorker();

                        if (!window.__onixOneSignalInitialized) {
                            try {
                                window.__onixOneSignalInitPromise = window.__onixOneSignalInitPromise || OneSignal.init({
                                    appId,
                                    allowLocalhostAsSecureOrigin: true,
                                });
                                await window.__onixOneSignalInitPromise;
                            } catch (error) {
                                if (!error || !String(error.message || error).includes('SDK already initialized')) {
                                    throw error;
                                }
                            }

                            window.__onixOneSignalInitialized = true;
                        }
                        this.oneSignalInitialized = true;

                        await OneSignal.login(externalId);
                        await OneSignal.User.addTags({
                            role: 'admin',
                            source: 'backoffice',
                        });

                        if (requestPermission && OneSignal.Notifications.permission !== true) {
                            await OneSignal.Notifications.requestPermission();
                        }

                        if (requestPermission || OneSignal.Notifications.permission === true) {
                            await OneSignal.User.PushSubscription.optIn();
                        }

                        this.oneSignalPushOptedIn = OneSignal.User.PushSubscription.optedIn;
                    } catch (error) {
                        console.error('Erro ao configurar OneSignal do administrador:', error);
                        this.oneSignalPushOptedIn = false;

                        if (requestPermission) {
                            this.snackbar.message = 'OneSignal Web Push não está configurado para este App ID.';
                            this.snackbar.color = 'warning';
                            this.snackbar.show = true;
                        }
                    }
                });
            } catch (error) {
                console.error('Erro ao inicializar OneSignal do administrador:', error);
                if (requestPermission) {
                    this.snackbar.message = 'Não foi possível ativar as notificações do OneSignal neste navegador.';
                    this.snackbar.color = 'warning';
                    this.snackbar.show = true;
                }
            }
        },

        async registerAdminPushSubscription(requestPermission = true) {
            if (!this.supportsAdminNotifications()) return;

            try {
                const config = await this.loadAdminPushConfig();
                if (config.provider !== 'internal' && config.provider !== 'both') return;

                this.syncNotificationPermission();

                if (this.notificationPermission === 'denied') {
                    this.snackbar.message = 'As notificações estão bloqueadas no navegador. Libere a permissão nas configurações do site.';
                    this.snackbar.color = 'warning';
                    this.snackbar.show = true;
                    return;
                }

                if (this.notificationPermission !== 'granted') {
                    if (!requestPermission) return;

                    this.notificationPermissionLoading = true;
                    this.notificationPermission = await Notification.requestPermission();
                }

                if (this.notificationPermission !== 'granted') return;

                const response = await axios.get('/api/v2/admin-push-subscriptions/public-key');
                const publicKey = response.data && response.data.content
                    ? response.data.content.publicKey
                    : null;

                if (!publicKey) return;

                await this.unregisterLegacyPushWorkers();

                // O registerServiceWorker.ts ja registra este mesmo arquivo. Aqui so
                // recuperamos o registro existente para configurar o push - chamar
                // register() e update() de novo fazia o navegador reavaliar o worker
                // a cada carga de tela, e o aviso de nova versao reaparecia sem parar.
                // Em desenvolvimento o registerServiceWorker nao registra nada, entao
                // garantimos o registro aqui antes de esperar por ele.
                if (!navigator.serviceWorker.controller) {
                    await navigator.serviceWorker.register('/service-worker.js', { scope: '/' });
                }

                const registration = await navigator.serviceWorker.ready;
                const applicationServerKey = this.urlBase64ToUint8Array(publicKey);
                let subscription = await registration.pushManager.getSubscription();

                if (subscription && !this.subscriptionUsesApplicationServerKey(subscription, applicationServerKey)) {
                    await this.removeAdminPushSubscription(subscription);
                    await subscription.unsubscribe();
                    subscription = null;
                }

                if (!subscription) {
                    subscription = await registration.pushManager.subscribe({
                        userVisibleOnly: true,
                        applicationServerKey,
                    });
                }

                await axios.post('/api/v2/admin-push-subscriptions', subscription.toJSON());
            } catch (error) {
                console.error('Erro ao registrar push web do administrador:', error);
                this.snackbar.message = 'Não foi possível ativar o Web Push neste navegador. Atualize a página e tente permitir novamente.';
                this.snackbar.color = 'warning';
                this.snackbar.show = true;
            } finally {
                this.notificationPermissionLoading = false;
                this.syncNotificationPermission();
            }
        },

        async unregisterLegacyPushWorkers() {
            const registrations = await navigator.serviceWorker.getRegistrations();

            await Promise.all(registrations.map(async (registration) => {
                const worker = registration.active || registration.waiting || registration.installing;
                const scriptUrl = worker && worker.scriptURL ? worker.scriptURL : '';
                // O service worker do PWA (que agora tambem trata o push) e os do
                // OneSignal precisam ser preservados: a limpeza serve apenas para
                // remover registros antigos que sobraram de versoes anteriores.
                const isAdminWorker = scriptUrl.endsWith('/service-worker.js');
                const isOneSignalWorker = scriptUrl.includes('OneSignalSDK');

                if (isAdminWorker || isOneSignalWorker) return;

                const subscription = await registration.pushManager.getSubscription();
                if (subscription) {
                    await this.removeAdminPushSubscription(subscription);
                    await subscription.unsubscribe();
                }

                await registration.unregister();
            }));
        },

        async unregisterInternalAdminPushWorker() {
            if (!('serviceWorker' in navigator)) return;

            const registrations = await navigator.serviceWorker.getRegistrations();

            await Promise.all(registrations.map(async (registration) => {
                const worker = registration.active || registration.waiting || registration.installing;
                const scriptUrl = worker && worker.scriptURL ? worker.scriptURL : '';

                if (scriptUrl.endsWith('/admin-web-push-worker.js')) {
                    await registration.unregister();
                }
            }));
        },

        async removeAdminPushSubscription(subscription) {
            try {
                await axios.delete('/api/v2/admin-push-subscriptions', {
                    data: { endpoint: subscription.endpoint },
                });
            } catch (error) {
                console.error('Erro ao remover subscription antiga de push:', error);
            }
        },

        urlBase64ToUint8Array(base64String) {
            const padding = '='.repeat((4 - base64String.length % 4) % 4);
            const base64 = (base64String + padding)
                .replace(/-/g, '+')
                .replace(/_/g, '/');

            const rawData = window.atob(base64);
            const outputArray = new Uint8Array(rawData.length);

            for (let i = 0; i < rawData.length; ++i) {
                outputArray[i] = rawData.charCodeAt(i);
            }

            return outputArray;
        },

        subscriptionUsesApplicationServerKey(subscription, applicationServerKey) {
            const currentKey = subscription.options && subscription.options.applicationServerKey;
            if (!currentKey) return false;

            const current = new Uint8Array(currentKey);
            if (current.length !== applicationServerKey.length) return false;

            for (let i = 0; i < current.length; i++) {
                if (current[i] !== applicationServerKey[i]) return false;
            }

            return true;
        },

    },
};
</script>

<style scoped lang="scss">
.app-shell {
    min-height: 100%;
    background: var(--v-background-base);
}

.app-content {
    min-height: calc(100vh - 64px);
}

.app-topbar {
    border-bottom: 1px solid var(--v-border-base) !important;
}

.notification-permission-banner {
    color: var(--v-dark-base);
    cursor: pointer;
    font-weight: 600;
}

.notification-permission-text {
    flex: 1;
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.user-avatar {
    cursor: pointer;
    font-size: 14px;
    font-weight: 600;
}

.logged-user {
    text-align: right;
    margin-right: 10px;
    font-size: 13px;
    font-weight: 400;
    flex-direction: column;
    cursor: pointer;
    line-height: 1.3;

    &-name {
        display: block;
    }

    &-email {
        display: block;
        font-size: 12px;
    }
}

.notification-menu {
    max-height: 420px;
    overflow-y: auto;
}

.notification-message {
    white-space: normal;
}
</style>
